import type { TFunction } from 'i18next';
import type { z } from 'zod';

type SendDayValuesType = {
  isEnabled: boolean;
  sendWeekday: string | null;
};

// An active mailing without send day would never be sent.
export const refineSendDayRequiredWhenActive = <
  S extends z.ZodType<SendDayValuesType>,
>(
  schema: S,
  t: TFunction<'common'>
): S =>
  schema.refine((values) => !values.isEnabled || values.sendWeekday !== null, {
    message: t('REPORTS.MAILING_FORM.ERRORS.SEND_DAY_REQUIRED'),
    path: ['sendWeekday'],
  });
